import { Injectable } from '@angular/core';

import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class AppendTokenInterceptor implements HttpInterceptor {

    constructor(
        private authService: AuthService) {
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const token = this.authService.token;

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let request: HttpRequest<any>;
        if (token) {
            request = req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + token)
            });
        } else {
            request = req;
        }
        return next.handle(request).pipe(
            tap(event => {
                if (event instanceof HttpResponse) {
                    const newToken = event.headers.get('Authorization');
                    if (newToken) {
                        this.authService.storeToken(newToken.substring('BEARER '.length));
                    }
                }
            })
        );
    }
}
